export const Ink = "#0F0F0F";
export const Blueprint = "#1D274A";
export const Zima = "#0086FF";
export const Honey = "#FFA520";
export const Scarlet = "#FF324B";
export const Amethyst = "#8E64E7";
export const Mint = "#38B8A5";
export const Pearl = "#FFF";
export const Mate = "#212B36";
